import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f809fd80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "middle tablet-plus" }
const _hoisted_5 = { class: "bottom" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "votes mr-2 mb-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: `/article/${_ctx.article.link}`,
      tag: "div",
      class: "image",
      style: _normalizeStyle(`--background-image: url('${_ctx.article.thumbnailImageUrl}')`)
    }, null, 8, ["to", "style"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: `/article/${_ctx.article.link}`,
          class: "no-link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(_ctx.article.title), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.article.summary), 1),
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.prettyTime(_ctx.article.creationDate)) + " · " + _toDisplayString(_ctx.article.author), 1),
        _hoisted_6
      ])
    ])
  ]))
}